const list = {
    path: 'contractOrder',
    component: resolve => require(['@/pages/admin/platform/contractOrder'], resolve)
}

export default list
